import { Button, Result } from "antd";
import { useNavigate } from "react-router-dom";
import RolesHelper from "../../common/services/permissions/RolesHelper";
import "./NotFound.scss";

// [CANA-649] Shown for any URL that matches no route, instead of a blank screen.
const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="not-found">
      <Result
        status="404"
        title="Page not found"
        subTitle="The page you are looking for does not exist."
        extra={
          <Button type="primary" onClick={() => navigate(RolesHelper.getRedirectPage(), { replace: true })}>
            Go to home
          </Button>
        }
      />
    </div>
  );
};

export default NotFound;
